import { createI18n } from 'vue-i18n'
import en from './locales/en'
import es from './locales/es'
import de_DE from './locales/de_DE'
import pt_BR from './locales/pt_BR'
import type { LocaleKey } from './constants'

// Get browser locale
const getBrowserLocale = (): LocaleKey => {
  const browserLocale = navigator.language.replace('-', '_')
  
  // Check if the browser locale matches our supported locales
  const supportedLocales: LocaleKey[] = ['en', 'es', 'de_DE', 'pt_BR']
  
  // First try exact match
  if (supportedLocales.includes(browserLocale as LocaleKey)) {
    return browserLocale as LocaleKey
  }
  
  // Then try matching just the language part
  const languageOnly = browserLocale.split('_')[0]
  const match = supportedLocales.find(locale => locale.startsWith(languageOnly))
  
  // Return matched locale or fallback to 'en'
  return match || 'pt_BR'
}

export const i18n = createI18n({
  legacy: false,
  locale: getBrowserLocale(),
  fallbackLocale: 'en',
  messages: {
    en,
    es,
    de_DE,
    pt_BR
  }
}) 

export default i18n 